<!--
  ~ Copyright (C) Schweizerische Bundesbahnen SBB, 2018.
  -->

<fieldset>
  <div class="form-group" [class.row]="!_detailViewComponent.smallScreen">
    <label
      class="col-form-label"
      [class.col-4]="!_detailViewComponent.smallScreen"
      [class.text-right]="!_detailViewComponent.smallScreen"
    >
      {{ prop.field_label | translate }}
    </label>
    <div [class.col-8]="!_detailViewComponent.smallScreen">
      <div class="input-group">
        <label class="col-form-label" *ngIf="prop.field_type !== 'date'" style="width:{{prop.max_length}}px;">
          {{ displayValue }}
        </label>
        <label class="col-form-label" *ngIf="prop.field_type === 'date'">
          {{ displayValue | esriDate: 'de-CH' }}
        </label>
      </div>
    </div>
  </div>
</fieldset>
